import { useEffect } from 'react';
import { identify } from '@zillow/universal-analytics';
import { useZillowSession } from 'src/services/auth/session/hooks';
import { MaybeString } from 'src/common/types';
import { initializeClickstream } from '../initializeClickstream';
import { getEncodedZUIDFromCookie } from './utils/getEncodedZUIDFromCookie';

const encodeSessionZUID = (zuid: MaybeString) => {
    if (!zuid) {
        return null;
    }
    return `X1-${zuid}`;
};

export const useClickstreamAnalytics = () => {
    const { session } = useZillowSession();
    const { user } = session ?? {};
    const { zuid } = user ?? {};
    useEffect(() => {
        initializeClickstream();

        const encodedZUID = getEncodedZUIDFromCookie();
        const clickstreamZUID = encodedZUID ?? encodeSessionZUID(zuid);
        if (!clickstreamZUID) {
            return;
        }

        identify(clickstreamZUID);
    }, [zuid]);
};
